/**
 * Client testimonials shown on the splash page (TestimonialsBass) and emitted
 * as schema.org Review + AggregateRating JSON-LD on the home route so search
 * engines and AI answer engines can extract them as machine-readable social
 * proof (Rich Results stars, Perplexity citations, etc.).
 */
export interface Testimonial {
  name: string;
  quote: string;
  rating: number;
}

export const TESTIMONIALS: Testimonial[] = [
  {
    name: "Kevin Y.",
    quote:
      "The real magic came from how my stylist combined my existing wardrobe in ways that I never thought of before. I got so many compliments after trying out one of the outfits made up of clothes that I've owned for years. It's been a while since I felt that excited and confident about what I was wearing.",
    rating: 5,
  },
  {
    name: "David K.",
    quote:
      "One of the best parts of working with Cello, were my likes/dislikes was authentically heard and adjustments made. Cello also made some suggestions to my apparel line-up that I would have never selected on my own, but very fitting to who I am, the social circles I move in, places I go, etc.",
    rating: 5,
  },
  {
    name: "Doug P.",
    quote:
      "I LOVE CELLO. My stylist reshaped my wardrobe and I have gotten so many compliments (\"wow! you wear clothes that actually fit you now!\" \"Where did you get that coat!\"). So glad I did this.",
    rating: 5,
  },
  {
    name: "Derrick P.",
    quote:
      "As a guy who only wore jeans and graphic t-shirts for the majority of his life, I wanted to upgrade my style, and I didn't realize how overwhelming the fashion world was. I found Cello to be super helpful in that transition...",
    rating: 5,
  },
  {
    name: "Ian D.",
    quote:
      "I had a wonderful experience working with the stylists at Cello. They gave great recommendations and really listened to my feedback throughout the process. This allowed me to experiment with new styles, and I discovered pieces that genuinely expanded my fashion range. Highly recommend if you're looking for a personalized styling service!",
    rating: 5,
  },
  {
    name: "Jerome C.",
    quote:
      "I wanted to upgrade my wardrobe so I reached out to Cello. They catalogued my existing wardrobe via video, I provided some information on what I was looking for, and in a few days I received outfit recommendations from my stylist. They even helped me put together a few outfits for my trip to New York. I now have a better understanding of how colors and patterns work together, which has helped making shopping for clothes much easier.",
    rating: 5,
  },
  {
    name: "David A.",
    quote:
      "Love Cello! The digital closet + stylist pairing is such a smart setup, way easier back and forth than I expected, and I walked away with a bunch of clothes I actually like wearing. They even tipped me off when items they picked for me went on sale for Black Friday. Great experience, highly recommend!",
    rating: 5,
  },
  {
    name: "Anders B.",
    quote:
      "Cello was a great experience! I've gained more confidence and get excited to go out now.",
    rating: 5,
  },
  {
    name: "Andrew A.",
    quote:
      "I've never used a stylist but this was great. I got affordable recommendations tailored to my existing clothes and then new clothes based on my existing style. Would highly recommend.",
    rating: 5,
  },
];
